import { get_json } from '../fetch';
import settings from '../settings';

export interface ITier {
    image: string;
    max_xp: number;
    name: string;
    xp: number;
    rewards: any[];
}

export interface ISeasonPass {
    image: string;
    name: string;
    tiers: ITier[];
}

export interface ISeason {
    name: string;
    pass: ISeasonPass;
}

class ProgressionService {
    async get_tiers(access_token: string): Promise<ITier[] | null> {
        try {
            const response = await get_json(`${settings.wow_server_url}/progression/tiers`, access_token);
            //console.log(response);
            return response;
        } catch (err) {
            console.error('failed to get tiers', err);
        }
        return null;
    }

    async get_seasons(access_token: string): Promise<ISeason[] | null> {
        try {
            const response = await get_json(`${settings.wow_server_url}/progression/seasons`, access_token);
            //console.log(response);
            return response;
        } catch (err) {
            console.error('failed to get seasons', err);
        }
        return null;
    }
}

const progression_service = new ProgressionService();
export default progression_service;
